import styled from 'styled-components';
import { Form } from '@/components';
import { COLORS } from '@/theme';
import { RadioGroup, Select } from '@/ui';

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
  gap: 1rem;
`;

export const StyledFormItemsBlock = styled('div')`
  width: 100%;
  display: flex;
  gap: 1rem;

  &&& div {
    flex: 1;
  }
`;

export const StyledDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${COLORS.BRIGHT_GRAY};
  margin: 1rem 0;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  align-items: center;
  height: 1.875rem;
`;

export const StyledSelect = styled(Select)`
  &&& {
    height: auto;
  }
`;

export const StyledUnitsSelect = styled(Select)`
  min-height: 2.75rem;
  font-size: 1rem;
  max-width: calc(50% - 0.5rem);
`;
